import { render, staticRenderFns } from "./prologueList.vue?vue&type=template&id=69d2b17a&scoped=true"
import script from "./prologueList.vue?vue&type=script&lang=js"
export * from "./prologueList.vue?vue&type=script&lang=js"
import style0 from "./prologueList.vue?vue&type=style&index=0&id=69d2b17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d2b17a",
  null
  
)

export default component.exports